//@ts-nocheck
import type { TAddAnimalWeightRequest, TDeleteAnimalWeightRequest, TEditAnimalWeightRequest } from './types';
import { API } from '@Providers';

export const initCSRF = async () => API({ endpoint: '/api/sanctum/csrf-cookie' });

export const login = async (email: string, password: string) => {
  await initCSRF();

  const payload = { email, password };

  return API({ endpoint: '/api/login', method: 'post', payload });
};

export const loginAs = async (id: string) => API({ endpoint: `/api/loginas/${id}` });

export const backToAdminSession = async (id: string) => API({ endpoint: `/api/backtoadmin/${id}` });

export const logout = async () => API({ endpoint: '/api/logout', method: 'post' });

export const sendPasswordResetEmail = async (email: string) =>
  API({ endpoint: '/api/password/reset-email', method: 'post', payload: { email } });

export const getProfile = async () => API({ endpoint: '/api/shelter/profile/get' });

export const getAnimalProfile = async (animalId: string) =>
  API({ endpoint: `/api/shelter/animal/get-animal-profile/${animalId}` });

export const getKennels = () => API({ endpoint: '/api/shelter/kennels/get-all-open-kennels' });

export const getFieldServicesFields = () => API({ endpoint: '/api/shelter/field-service-v2/get-field-service-fields' });

export const getFieldServicesMapFields = () => API({ endpoint: '/api/shelter/field-service-v2/get-map-fields' });

export const getFieldServicesMapData = (start: string, end: string, query: string) =>
  API({ endpoint: `/api/shelter/field-service-v2/call/map/${start}/${end}?${query}` });

export const updateAnimalStatus = (payload: any) =>
  API({ endpoint: '/api/shelter/animal/update-animal-status', method: 'post', payload });

export const updateAnimalLocation = (payload: any) =>
  API({ endpoint: '/api/shelter/animal/update-animal-location', method: 'post', payload });

export const addAnimalWeight = (payload: TAddAnimalWeightRequest) =>
  API({ endpoint: '/api/shelter/medical/add-weight', method: 'post', payload });

export const editAnimalWeight = (payload: TEditAnimalWeightRequest) =>
  API({ endpoint: '/api/shelter/medical/edit-weight', method: 'post', payload });

export const deleteAnimalWeight = (payload: TDeleteAnimalWeightRequest) =>
  API({ endpoint: '/api/shelter/medical/delete-weight', method: 'post', payload });

export const deleteAnimal = (animalId: string, payload: any) =>
  API({ endpoint: '/api/shelter/animal/delete/${animalId}', method: 'post', payload });
